var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"header-inner is-fixed transition",class:{'header-visible-top': _vm.isHeaderAttachedTop}},[_c('div',{staticClass:"nav-wrapper"},[_c('v-nav',{on:{"OnHeaderElementFocus":_vm.OnHeaderElementFocus}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }